import { PAYMENT_TYPES } from "../config/lipaBidhaaConfig";
import { PaybillFields } from "../fields/PaybillFields";
import { AliasAmountFields } from "../fields/AliasAmountFields";
import {
  tillValidators,
  paykitValidators,
} from "../validations/lipaBidhaaValidations";

export function Step1Details({
  paymentType,
  control,
  onNext,
  isLoading,
  walletBalance,
  isBalanceError,
}) {
  switch (paymentType) {
    case PAYMENT_TYPES.PAYBILL:
      return (
        <PaybillFields
          control={control}
          onNext={onNext}
          isLoading={isLoading}
          walletBalance={walletBalance}
          isBalanceError={isBalanceError}
        />
      );
    case PAYMENT_TYPES.TILL_NUMBER:
      return (
        <AliasAmountFields
          control={control}
          onNext={onNext}
          isLoading={isLoading}
          walletBalance={walletBalance}
          isBalanceError={isBalanceError}
          validators={tillValidators}
        />
      );
    case PAYMENT_TYPES.B2B:
      return (
        <AliasAmountFields
          control={control}
          onNext={onNext}
          isLoading={isLoading}
          walletBalance={walletBalance}
          isBalanceError={isBalanceError}
          validators={paykitValidators}
        />
      );
    default:
      return null;
  }
}
